import { render, staticRenderFns } from "./backoffice-pre-anestesico.vue?vue&type=template&id=adcd774a&scoped=true"
import script from "./backoffice-pre-anestesico.vue?vue&type=script&lang=ts"
export * from "./backoffice-pre-anestesico.vue?vue&type=script&lang=ts"
import style0 from "./backoffice-pre-anestesico.vue?vue&type=style&index=0&id=adcd774a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "adcd774a",
  null
  
)

export default component.exports